import iconFiveColumns from './ColumnsBlock/icons/five-columns-equal.svg';
import iconFourColumns from './ColumnsBlock/icons/four-columns-equal.svg';
import iconOneColumn from './ColumnsBlock/icons/one-column.svg';
import iconSixColumns from './ColumnsBlock/icons/six-columns-equal.svg';
import iconThreeColumns255025 from './ColumnsBlock/icons/three-columns-25-50-25.svg';
import iconThreeColumns from './ColumnsBlock/icons/three-columns-equal.svg';
import iconTwoColumns2080 from './ColumnsBlock/icons/two-columns-20-80.svg';
import iconTwoColumns3070 from './ColumnsBlock/icons/two-columns-30-70.svg';
import iconTwoColumns4060 from './ColumnsBlock/icons/two-columns-40-60.svg';
import iconTwoColumns6040 from './ColumnsBlock/icons/two-columns-60-40.svg';
import iconTwoColumns7030 from './ColumnsBlock/icons/two-columns-70-30.svg';
import iconTwoColumns8020 from './ColumnsBlock/icons/two-columns-80-20.svg';
import iconTwoColumns from './ColumnsBlock/icons/two-columns-equal.svg';

export const gridSizes = {
  full: {
    mobile: 12,
    tablet: 12,
    computer: 12,
  },
  halfWidth: {
    mobile: 12,
    tablet: 6,
    computer: 6,
  },
  twoThirds: {
    mobile: 12,
    tablet: 8,
    computer: 8,
  },
  oneThird: {
    mobile: 12,
    tablet: 4,
    computer: 4,
  },
  halfWidthBig: {
    mobile: 12,
    tablet: 8,
    computer: 6,
  },
  oneThirdSmall: {
    mobile: 12,
    tablet: 2,
    computer: 3,
  },
  oneQuarter: {
    mobile: 12,
    tablet: 6,
    computer: 3,
  },

  /**
   * Base 12 com arredondamento favorecendo a coluna menor.
   *
   * 20% em base 12 seria 2.4.
   * Em vez de arredondar para 2, usamos 3,
   * para a menor coluna receber mais margem visual.
   *
   * 20/80 vira 3/9.
   */
  oneFifth: {
    mobile: 12,
    tablet: 3,
    computer: 3,
  },

  /**
   * Complemento de oneFifth para fechar 12.
   *
   * 80% em base 12 seria 9.6.
   * Como a menor ficou com 3, a maior fica com 9.
   *
   * 9 + 3 = 12
   */
  fourFifths: {
    mobile: 12,
    tablet: 9,
    computer: 9,
  },

  /**
   * 40% em base 12 seria 4.8.
   * Arredonda para 5 para favorecer a menor.
   *
   * Usado em 40/60 e 60/40.
   */
  twoFifths: {
    mobile: 12,
    tablet: 5,
    computer: 5,
  },

  /**
   * Complemento de twoFifths para fechar 12.
   *
   * 60% em base 12 seria 7.2.
   * Como a menor ficou com 5, a maior fica com 7.
   *
   * 7 + 5 = 12
   */
  threeFifths: {
    mobile: 12,
    tablet: 7,
    computer: 7,
  },
  oneSixth: {
    mobile: 12,
    tablet: 2,
    computer: 2,
  },
};

export const variants = [
  {
    icon: iconTwoColumns,
    defaultData: {
      gridSize: 12,
      gridCols: ['halfWidth', 'halfWidth'],
    },
    common: true,
    cols: 2,
  },
  {
    icon: iconTwoColumns2080,
    defaultData: {
      gridSize: 12,
      gridCols: ['oneFifth', 'fourFifths'],
    },
    common: true,
    cols: 2,
    title: '20 | 80',
  },
  {
    icon: iconTwoColumns3070,
    defaultData: {
      gridSize: 12,
      gridCols: ['oneThird', 'twoThirds'],
    },
    common: true,
    cols: 2,
    title: '30 | 70',
  },
  {
    icon: iconTwoColumns7030,
    defaultData: {
      gridSize: 12,
      gridCols: ['twoThirds', 'oneThird'],
    },
    common: true,
    cols: 2,
    title: '70 | 30',
  },
  {
    icon: iconTwoColumns8020,
    defaultData: {
      gridSize: 12,
      gridCols: ['fourFifths', 'oneFifth'],
    },
    common: true,
    cols: 2,
    title: '80 | 20',
  },
  {
    icon: iconThreeColumns,
    defaultData: {
      gridSize: 12,
      gridCols: ['oneThird', 'oneThird', 'oneThird'],
    },
    common: true,
    cols: 3,
  },
  {
    icon: iconThreeColumns255025,
    defaultData: {
      gridSize: 12,
      gridCols: ['oneThirdSmall', 'halfWidthBig', 'oneThirdSmall'],
    },
    common: true,
    cols: 3,
    title: '25 | 50 | 25',
  },
  {
    icon: iconFourColumns,
    defaultData: {
      gridSize: 12,
      gridCols: ['oneQuarter', 'oneQuarter', 'oneQuarter', 'oneQuarter'],
    },
    common: true,
    cols: 4,
  },
  {
    icon: iconOneColumn,
    defaultData: {
      gridSize: 12,
      gridCols: ['full'],
    },
    common: true,
    cols: 1,
    title: '100%',
  },
  {
    icon: iconTwoColumns6040,
    defaultData: {
      gridSize: 12,
      gridCols: ['threeFifths', 'twoFifths'],
    },
    common: true,
    cols: 2,
    title: '60 | 40',
  },
  {
    icon: iconTwoColumns4060,
    defaultData: {
      gridSize: 12,
      gridCols: ['twoFifths', 'threeFifths'],
    },
    common: true,
    cols: 2,
    title: '40 | 60',
  },
  {
    icon: iconFiveColumns,
    defaultData: {
      gridSize: 12,
      gridCols: ['oneFifth', 'oneFifth', 'oneFifth', 'oneFifth', 'oneFifth'],
    },
    common: true,
    cols: 5,
  },
  {
    icon: iconSixColumns,
    defaultData: {
      gridSize: 12,
      gridCols: [
        'oneSixth',
        'oneSixth',
        'oneSixth',
        'oneSixth',
        'oneSixth',
        'oneSixth',
      ],
    },
    common: true,
    cols: 6,
  },
];
